export default {
  namespaced    : true,

  state         : {
    userData    : {
      name        : '',
      displayname : '',
      
      lastChecked : null
    },
  },

  mutations: {
    setUser(state, payload){
      for(let key in state.userData){
        if (typeof payload[key] === 'undefined') continue;

        state.userData[key] = payload[key];
      }
      
      state.userData.lastChecked = (new Date());
    },

    clearUser(state){
      state.userData = {
        name        : '',
        displayname : '',
        
        lastChecked : null
      };
    },

    resetStore(state){
      state.userData.name         = '';
      state.userData.displayname  = '';
      state.userData.lastChecked  = null;
    }
  },

  actions : {
    async initializeUserData(){
      // console.log(context);
      return {status : 200};
      
      // const results = await context.dispatch({
      //   type  : 'requests/user/getMeta'
      // }, { root: true });

      // switch(results.status){
      //   case 200:
      //     if(typeof results.data.user !== 'undefined'){
      //       context.commit('setUser', results.data.user);
      //     }

      //     if(typeof results.data.character !== 'undefined'){
      //       context.dispatch({
      //         type      : 'userCharacter/updateUserCharacter',
      //         data      : results.data.character
      //       }, {root:true});

      //       context.dispatch({
      //         type      : 'knownCharacter/setCharacter',
      //         character : results.data.character
      //       }, {root:true});
      //     }

      //     if(typeof results.data.characterMeta !== 'undefined'){
      //       context.dispatch({
      //         type  : 'userCharacter/getMeta',
      //         data  : results.data.characterMeta
      //       }, {root:true});
      //     }
      //   break;
      // }

      // return results;
    },

    async clearUserAndCharacter(context){
      context.commit('clearUser');

      // context.dispatch({
      //   type : 'userCharacter/clearCharacter'
      // }, { root: true });
    },

    async changeUserCharacterIDName(context, payload){
      const results = await context.dispatch({
        type  : 'requests/user/changeUserCharacterIDName',
        name  : payload.name,
      }, {root: true});

      switch(results.status){
        case 200:
          // 変更が完了したら、現在持っているローカルのデータを更新します。
          await context.dispatch('initializeUserData');
        break;
      }
      
      return results;
    },

    async hasUserCharacterIDName(context){
      if(context.state.userData.lastChecked === null){
        await context.dispatch('initializeUserData');
      }
      
      if( (context.state.userData.name === null) && (context.rootState.userCharacter.characterData.name === null) ){
        return false;
      }else{
        return true;
      }
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
};
